import React from 'react';
import VistaFabbisogno from './fabbisogni/VistaFabbisogno';

// ─────────────────────────────────────────────────────────────────────────────
// FabbisogniMerce — vista in tempo reale dei fabbisogni di merce,
// calcolata da ordini confermati e distinte confermate.
// L'intera pagina è implementata dal componente condiviso VistaFabbisogno.
// ─────────────────────────────────────────────────────────────────────────────
export default function FabbisogniMerce() {
  return (
    <VistaFabbisogno
      categoria="merce"
      titolo="Fabbisogni Merce"
      permessoModulo="commerciale.fabbisogni"
    />
  );
}
